<header id="qg-site-header" class="qg-site-header sticky">
  <div class="container-fluid qg-site-width qg-site-header-top">
    <div class="row align-items-center justify-content-between">
      <button id="qg-show-menu" class="qg-show-menu" aria-label="Search" data-toggle="collapse"
        data-target=".qg-navigation" aria-expanded="false" aria-controls="qg-site-nav qg-portal-links">
        <div class="qg-global-icons ">
          <div class="qg-icon--menu-default">
            <svg width="512px" height="512px" viewBox="0 0 512 512">
              <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <rect x="72" y="95" width="368" height="60" rx="15"></rect>
                <rect x="72" y="226" width="368" height="59" rx="15"></rect>
                <rect x="72" y="356" width="368" height="60" rx="15"></rect>
              </g>
            </svg>
          </div>
          <div class="qg-icon--menu-close">
            <svg width="512px" height="512px" viewBox="0 0 512 512">
              <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <rect
                  transform="translate(256.500000, 256.000000) scale(1, -1) rotate(45.000000) translate(-256.500000, -256.000000) "
                  x="32" y="220" width="449" height="72" rx="15"></rect>
                <rect
                  transform="translate(256.500000, 256.000000) rotate(45.000000) translate(-256.500000, -256.000000) "
                  x="32" y="220" width="449" height="72" rx="15"></rect>
              </g>
            </svg>
          </div>
        </div>
        <span>Menu</span>
      </button>

      <div class="qg-coat-of-arms">
        <a href="//www.qld.gov.au" tabindex="0">
          <img src="https://static.qgov.net.au/assets/v4/latest/images/coat-of-arms/qg-coa-white.svg"
            alt="Queensland Government" class="hidden-xs">
          <img src="https://static.qgov.net.au/assets/v4/latest/images/coat-of-arms/qg-coa-stacked-white.svg"
            alt="Queensland Government" class="hidden-sm hidden-md hidden-lg">
          <img src="https://static.qgov.net.au/assets/v4/latest/images/coat-of-arms/qg-coa-stacked.svg"
            alt="Queensland Government" class="hidden-xs hidden-sm hidden-md hidden-lg qg-print-coat-of-arms">
        </a>
      </div>


      <button id="qg-show-search" class="qg-show-search" aria-label="Search" data-toggle="collapse"
        data-target="#qg-global-search-form" aria-expanded="false">
        <div class="qg-global-icons ">
          <div class="qg-icon--mobile-search-default">
            <svg width="512px" height="512px" viewBox="0 0 512 512">
              <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g transform="translate(67.298684, 71.201316)">
                  <path
                    d="M108.7791,227.405285 L11.3079182,324.876467 C5.45005384,330.734332 5.45005384,340.231806 11.3079182,346.089671 L27.4103294,362.192082 C33.2681938,368.049946 42.7656685,368.049946 48.6235328,362.192082 L146.094715,264.7209 C151.952579,258.863035 151.952579,249.365561 146.094715,243.507696 L129.992304,227.405285 C124.134439,221.547421 114.636965,221.547421 108.7791,227.405285 Z">
                  </path>
                  <path
                    d="M221.701316,0.798683501 C305.096314,0.798683501 372.701316,68.6275439 372.701316,152.298684 C372.701316,235.969823 305.096314,303.798684 221.701316,303.798684 C138.306319,303.798684 70.7013165,235.969823 70.7013165,152.298684 C70.7013165,68.6275439 138.306319,0.798683501 221.701316,0.798683501 Z M221.310125,54.0389936 C167.081772,54.0389936 123.121006,98.2066236 123.121006,152.690156 C123.121006,207.173689 167.081772,251.341319 221.310125,251.341319 C275.538478,251.341319 319.499244,207.173689 319.499244,152.690156 C319.499244,98.2066236 275.538478,54.0389936 221.310125,54.0389936 Z"
                    fill-rule="nonzero"
                    transform="translate(221.701316, 152.298684) scale(-1, 1) translate(-221.701316, -152.298684) ">
                  </path>
                </g>
              </g>
            </svg>
          </div>
          <div class="qg-icon--menu-close">
            <svg width="512px" height="512px" viewBox="0 0 512 512">
              <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <rect
                  transform="translate(256.500000, 256.000000) scale(1, -1) rotate(45.000000) translate(-256.500000, -256.000000) "
                  x="32" y="220" width="449" height="72" rx="15"></rect>
                <rect
                  transform="translate(256.500000, 256.000000) rotate(45.000000) translate(-256.500000, -256.000000) "
                  x="32" y="220" width="449" height="72" rx="15"></rect>
              </g>
            </svg>
          </div>
        </div>
        <span>Search</span>
      </button>

      <form action="https://www.qld.gov.au/search" id="qg-global-search-form" role="search"
        class="qg-site-search__form qg-search-form collapse qg-global-web-autocomplete"
        data-suggestions="https://find.search.qld.gov.au/s/suggest.json?collection=qld-gov&fmt=json%2B%2B&alpha=0.5&profile=qld"
        data-results-url="https://find.search.qld.gov.au/s/search.json?collection=qld-gov&profile=qld&meta_sfinder_sand=yes">
        <div class="input-group">
          <label for="qg-search-query" class="qg-visually-hidden">Search Queensland Government</label>
          <input type="text" name="query" id="qg-search-query" class="form-control qg-search-site__input"
            autocomplete="off" placeholder="Search website" tabindex="0" aria-required="true" aria-expanded="false" />
          <svg class="qg-search__icon" width="512px" height="512px" viewBox="0 0 512 512">
            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g transform="translate(67.298684, 71.201316)">
                <path
                  d="M108.7791,227.405285 L11.3079182,324.876467 C5.45005384,330.734332 5.45005384,340.231806 11.3079182,346.089671 L27.4103294,362.192082 C33.2681938,368.049946 42.7656685,368.049946 48.6235328,362.192082 L146.094715,264.7209 C151.952579,258.863035 151.952579,249.365561 146.094715,243.507696 L129.992304,227.405285 C124.134439,221.547421 114.636965,221.547421 108.7791,227.405285 Z">
                </path>
                <path
                  d="M221.701316,0.798683501 C305.096314,0.798683501 372.701316,68.6275439 372.701316,152.298684 C372.701316,235.969823 305.096314,303.798684 221.701316,303.798684 C138.306319,303.798684 70.7013165,235.969823 70.7013165,152.298684 C70.7013165,68.6275439 138.306319,0.798683501 221.701316,0.798683501 Z M221.310125,54.0389936 C167.081772,54.0389936 123.121006,98.2066236 123.121006,152.690156 C123.121006,207.173689 167.081772,251.341319 221.310125,251.341319 C275.538478,251.341319 319.499244,207.173689 319.499244,152.690156 C319.499244,98.2066236 275.538478,54.0389936 221.310125,54.0389936 Z"
                  fill-rule="nonzero"
                  transform="translate(221.701316, 152.298684) scale(-1, 1) translate(-221.701316, -152.298684) ">
                </path>
              </g>
            </g>
          </svg>
          <button class="qg-search-close-concierge hide" type="button" aria-label="Close Search Concierge">
            <svg width="512px" height="512px" viewBox="0 0 512 512">
              <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <rect
                  transform="translate(256.500000, 256.000000) scale(1, -1) rotate(45.000000) translate(-256.500000, -256.000000) "
                  x="32" y="220" width="449" height="72" rx="15"></rect>
                <rect
                  transform="translate(256.500000, 256.000000) rotate(45.000000) translate(-256.500000, -256.000000) "
                  x="32" y="220" width="449" height="72" rx="15"></rect>
              </g>
            </svg>
          </button>
          <button type="submit" id="feature-search-submit" class="btn btn-global-primary" title="Search site"
            data-analytics-link-group="qg-global-search-submit">Search</button>
          <div class="qg-search-concierge qg-search-concierge-initial">
            <div class="qg-search-concierge-group helper">
              <div class="qg-search-concierge-content">
                <h4>Popular services</h4>
                <ul class="list-group">
                  <li class="list-group-item"><a
                      href="https://www.service.transport.qld.gov.au/renewregistration/public/Welcome.xhtml?"
                      tabindex="-1" data-analytics-link-group="qg-global-search-popular-services">Renew vehicle or boat
                      rego</a></li>
                  <li class="list-group-item"><a
                      href="https://www.service.transport.qld.gov.au/checkmydemeritpoints/public/Welcome.xhtml?"
                      tabindex="-1" data-analytics-link-group="qg-global-search-popular-services">Check my licence
                      demerit points</a></li>
                  <li class="list-group-item"><a
                      href="https://www.qld.gov.au/transport/licensing/driver-licensing/renew-replace/renew/online"
                      tabindex="-1" data-analytics-link-group="qg-global-search-popular-services">Renew my driving
                      licence</a></li>
                  <li class="list-group-item"><a href="https://www.change-of-address.services.qld.gov.au" tabindex="-1"
                      data-analytics-link-group="qg-global-search-popular-services">Change my address</a></li>
                </ul>
              </div>
            </div>
            <div class="qg-search-concierge-group helper">
              <div class="qg-search-concierge-content">
                <h4>Browse by category</h4>
                <ul class="list-group">
                  <li class="list-group-item"><a tabindex="-1"
                      href="https://www.qld.gov.au/queenslanders/transport-and-motoring">Transport and motoring</a></li>
                  <li class="list-group-item"><a tabindex="-1"
                      href="https://www.qld.gov.au/queenslanders/employment-and-jobs">Employment and jobs</a></li>
                  <li class="list-group-item"><a tabindex="-1"
                      href="https://www.qld.gov.au/queenslanders/education-and-training">Education and training</a></li>
                  <li class="list-group-item"><a tabindex="-1"
                      href="https://www.qld.gov.au/queenslanders/queensland-and-its-government">Queensland and its
                      government</a></li>
                </ul>
                <a href="https://www.qld.gov.au/queenslanders" tabindex="-1" class="all"
                  data-analytics-link-group="qg-global-search-category">Browse all categories</a>
              </div>
            </div>
          </div>
          <div class="qg-search-concierge qg-search-concierge-help">
            <div class="qg-search-concierge-group suggestions">
              <div class="qg-search-concierge-content">
                <h4>Suggestions</h4>
                <ul class="list-group">
                  <li class="list-group-item"><button tabindex="-1"
                      data-analytics-link-group="qg-global-search-suggestion"><b>canc</b>el registration for
                      osconnect</button></li>
                  <li class="list-group-item"><button tabindex="-1"
                      data-analytics-link-group="qg-global-search-suggestion"><b>canc</b>el a booking</button></li>
                  <li class="list-group-item"><button tabindex="-1"
                      data-analytics-link-group="qg-global-search-suggestion"><b>canc</b>el vehicle or boat
                      registration</button></li>
                </ul>
              </div>
            </div>
            <div class="qg-search-concierge-group highlight">
              <div class="qg-search-concierge-content">
                <div class="d-flex justify-content-between align-content-center flex-wrap">
                  <h4>Need to cancel your rego?</h4>
                  <div>
                    <span class="fa fa-car"></span>
                    <span class="fa fa-motorcycle"></span>
                    <span class="fa fa-anchor"></span>
                  </div>
                </div>
                <p>Save time and cancel your vehicle or boat registration online.</p>
                <a href="#" tabindex="-1" class="btn btn-global-primary-white"
                  data-analytics-link-group="qg-global-search-feature">Cancel my registration</a>
              </div>
            </div>
            <div class="qg-search-concierge-group helper">
              <div class="qg-search-concierge-content">
                <h4>Related services</h4>
                <ul class="list-group">
                  <li class="list-group-item"><a tabindex="-1" href="#"
                      data-analytics-link-group="qg-global-search-related-service">Cancel a booking</a></li>
                  <li class="list-group-item"><a tabindex="-1" href="#"
                      data-analytics-link-group="qg-global-search-related-service">Cancel first aid training</a></li>
                  <li class="list-group-item"><a tabindex="-1" href="#"
                      data-analytics-link-group="qg-global-search-related-service">Cancel a disability parking
                      permit</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <!--parameters to display results on search page-->
        <input type="hidden" name="num_ranks" value="10">
        <input type="hidden" name="tiers" value="off">
        <input type="hidden" name="collection" value="qld-gov">
        <input type="hidden" name="profile" value="qld">
      </form>


    </div>
  </div>
  <div id="qg-portal-links" class="qg-portal-links qg-navigation collapse">
    <div class="container-fluid qg-site-width">
      <nav class="navbar navbar-expand">
        <div class="collapse navbar-collapse" id="qgPortalLinksDropdown">
          <ul class="qg-portal-links__list navbar-nav">
            <li class="nav-item">
              <a class="nav-link" href="https://www.qld.gov.au/services#/"
                data-analytics-link-group=“qg-portal-links-link“>Find services</a>
            </li>
            <li class="nav-item dropdown">
              <button class="qg-portal-links__btn dropdown-toggle" type="button" id="qgPortalLinkBusiness"
                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Business and industry</button>
              <div class="dropdown-menu dropdown-menu-right" aria-labelledby="qgPortalLinkBusiness">
                <div class="qg-dropdown-wrapper">
                  <a class="dropdown-item" href="https://www.business.qld.gov.au/starting-business"
                    data-analytics-link-group=“qg-portal-links-link“>Starting a business</a>
                  <a class="dropdown-item" href="https://www.business.qld.gov.au/running-business"
                    data-analytics-link-group=“qg-portal-links-link“>Running a business</a>
                  <a class="dropdown-item" href="https://www.business.qld.gov.au/running-business/employing"
                    data-analytics-link-group=“qg-portal-links-link“>Employing people</a>
                  <a class="dropdown-item" href="https://www.business.qld.gov.au/running-business/employing/payroll-tax"
                    data-analytics-link-group=“qg-portal-links-link“>Payroll tax</a>
                  <a class="dropdown-item" href="https://www.business.qld.gov.au/industries"
                    data-analytics-link-group=“qg-portal-links-link“>Industries</a>
                  <a class="dropdown-item" href="https://www.business.qld.gov.au/industries/invest"
                    data-analytics-link-group=“qg-portal-links-link“>Investing in Queensland</a>
                  <a class="qg-dropdown-all dropdown-item" href="https://www.business.qld.gov.au/"
                    data-analytics-link-group=“qg-portal-links-all-category“>All categories</a>
                </div>
              </div>
            </li>
            <li class="nav-item dropdown">
              <button class="qg-portal-links__btn dropdown-toggle" type="button" id="qgPortalLinkGovernment"
                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Government employees</button>
              <div class="dropdown-menu dropdown-menu-right" aria-labelledby="qgPortalLinkGovernment">
                <div class="qg-dropdown-wrapper">
                  <a class="dropdown-item" href="https://www.forgov.qld.gov.au/working-in-the-public-service"
                    data-analytics-link-group=“qg-portal-links-link“>Working in the public service</a>
                  <a class="dropdown-item" href="https://www.forgov.qld.gov.au/human-resources"
                    data-analytics-link-group=“qg-portal-links-link“>Human resources</a>
                  <a class="dropdown-item" href="https://www.forgov.qld.gov.au/finance-and-procurement"
                    data-analytics-link-group=“qg-portal-links-link“>Finance and procurement</a>
                  <a class="dropdown-item" href="https://www.forgov.qld.gov.au/ict"
                    data-analytics-link-group=“qg-portal-links-link“>Information and communication technology</a>
                  <a class="dropdown-item" href="https://www.forgov.qld.gov.au/service-delivery-and-community-support"
                    data-analytics-link-group=“qg-portal-links-link“>Service delivery and community support</a>
                  <a class="dropdown-item" href="https://www.forgov.qld.gov.au/mail-facilities-vehicles"
                    data-analytics-link-group=“qg-portal-links-link“>Mail, facilities and vehicles</a>
                  <a class="qg-dropdown-all dropdown-item" href="https://www.forgov.qld.gov.au/"
                    data-analytics-link-group=“qg-portal-links-all-category“>All categories</a>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  </div>

  <div class="container-fluid qg-site-width qg-site-header-bottom">
    <div class="row align-items-center justify-content-between">

      <nav id="qg-site-nav" class="qg-navigation collapse" role="navigation" aria-label="Main navigation">
        <ul class="nav">
          <li class="nav-item hidden-lg hidden-md">
            <a class="nav-link" href="/" data-analytics-link-group="qg-primary-nav-link">Home</a>
          </li>
          <li class="nav-item dropdown mega-dropdown">
            <button class="nav-link dropdown-toggle" data-flip="false" data-toggle="dropdown"
              id="qgPrimaryNavForQueenslanders" aria-haspopup="true" aria-expanded="false">For Queenslanders</button>
            <div class="dropdown-menu mega-menu" aria-labelledby="qgPrimaryNavForQueenslanders">
              <ul>
                <li><a href="https://www.qld.gov.au/transport" data-analytics-link-group="qg-primary-nav-link">Transport
                    and motoring</a></li>
                <li><a href="https://www.qld.gov.au/jobs" data-analytics-link-group="qg-primary-nav-link">Employment and
                    jobs</a></li>
                <li><a href="https://www.qld.gov.au/education" data-analytics-link-group="qg-primary-nav-link">Education
                    and training</a></li>
                <li><a href="https://www.qld.gov.au/about" data-analytics-link-group="qg-primary-nav-link">Queensland
                    and its government</a></li>
                <li><a href="https://www.qld.gov.au/health" data-analytics-link-group="qg-primary-nav-link">Health and
                    wellbeing</a></li>
                <li><a href="https://www.qld.gov.au/community" data-analytics-link-group="qg-primary-nav-link">Community
                    support</a></li>
                <li><a href="https://www.qld.gov.au/emergency" data-analytics-link-group="qg-primary-nav-link">Emergency
                    services and safety</a></li>
                <li><a href="https://www.qld.gov.au/law" data-analytics-link-group="qg-primary-nav-link">Your rights,
                    crime and the law</a></li>
                <li><a href="https://www.qld.gov.au/environment"
                    data-analytics-link-group="qg-primary-nav-link">Environment, land and water</a></li>
                <li><a href="https://www.qld.gov.au/housing" data-analytics-link-group="qg-primary-nav-link">Homes and
                    housing</a></li>
                <li><a href="https://www.qld.gov.au/recreation"
                    data-analytics-link-group="qg-primary-nav-link">Recreation, sport and arts</a></li>
                <li><a href="https://www.qld.gov.au/families" data-analytics-link-group="qg-primary-nav-link">Parents
                    and families</a></li>
                <li><a href="https://www.qld.gov.au/disability" data-analytics-link-group="qg-primary-nav-link">People
                    with disability</a></li>
                <li><a href="https://www.qld.gov.au/youth" data-analytics-link-group="qg-primary-nav-link">Youth</a>
                </li>
                <li><a href="https://www.qld.gov.au/atsi" data-analytics-link-group="qg-primary-nav-link">Aboriginal and
                    Torres Strait Islander peoples</a></li>
                <li><a href="https://www.qld.gov.au/seniors" data-analytics-link-group="qg-primary-nav-link">Seniors</a>
                </li>
              </ul>
              <div class="d-flex flex-row-reverse">
                <a href="https://www.qld.gov.au/queenslanders" class="btn btn-global-primary"
                  data-analytics-link-group=“qg-primary-nav-browse-all“>Browse all information and services</a>
              </div>
            </div>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="https://www.qld.gov.au/contact-us"
              data-analytics-link-group="qg-primary-nav-link">Contact us</a>
          </li>
        </ul>
      </nav>


      <div class="header-location">
        <div class="header-location__title">
          <span class="header-location__label">Your location is</span>
          <button class="dropdown-toggle" type="button" data-toggle="collapse" data-target="#qg-location-dropdown"
            aria-expanded="false" aria-controls="qg-location-dropdown" aria-label="Your location is unknown">
            <span class="location-name">unknown</span>
          </button>
          <span class="header-location__icon fa fa-map-marker"></span>
        </div>
        <div class="dropdown-menu qg-location-setter collapse" id="qg-location-dropdown">
          <div class="qg-location-default">
            <p>Help us provide you with the most useful information by setting your location.</p>
            <button class="btn btn-global-primary detect-location" type="button">Use device location</button>
            <span class="qg-location-setter-divider">or</span>
            <form class="qg-location-setter-form" action="#">
              <label>Start typing your town or suburb</label>
              <p class="qg-location-setter-error error hide">Please enter a location into the search box and try
                searching again.</p>
              <input type="text" aria-label="Start typing your town or suburb, e.g. Cooladdi" data-choice=""
                placeholder="e.g. Cooladdi" />
              <div class="qg-location-setter-autocomplete hide">
                <ul>
                  <li><button><b>Coola</b>bine, Sunshine Coast Regional</button></li>
                  <li><button><b>Coola</b>bunia, South Burnett Regional</button></li>
                  <li><button><b>Coola</b>ddi, Murweh Shire</button></li>
                  <li><button><b>Coola</b>na, Somerset Regional</button></li>
                  <li><button><b>Coola</b>ngatta, Gold Coast City</button></li>
                </ul>
              </div>
              <button class="btn btn-global-primary set-location" type="button">Set location</button>
            </form>

          </div>
          <div class="qg-location-set hide">
            <button class="btn btn-global-primary clear-location" type="button">Clear location</button>
          </div>
          <button class="qg-location-setter-close">Close</button>

        </div>
      </div>

    </div>
  </div>
</header>
